import { writable, readable } from 'svelte/store';

// selectedLayout, indicate the design layout (mobile/desktop, etc)
//    0 - Mobile
//    1 - Mobile 2
//    2 - Mobile 3
//    3 - Desktop
export const selectedLayout = writable(3);
export const layouts = [
  'Mobile',
  'Mobile 2',
  'Mobile 3',
  'Desktop',
];

// foregroundPosition will be a number, 0–3
//    0 - bottom-left
//    1 - bottom-right
//    2 - top-right
//    3 - top-left
export const foregroundPosition = writable(0);

// startingDay is 0-indexed like the built-in JS week
//    0 - Sunday
//    1 - Monday
//    2 - Tuesday
//    3 - Wednesday
//    4 - Thursday
//    5 - Friday
//    6 - Saturday
export const startingDay = writable(0);

// selectedBackground, the selected index
//    see backgrounds.js
export const selectedBackground = writable(0);
// export const selectedBackground = writable(1);
// export const selectedBackground = writable(22);
// export const selectedBackground = writable(12);
// export const selectedBackground = writable(24);

// month used to generate the calendar and labels
//     0 - January
//     1 - February
//     2 - March
//     3 - April
//     4 - May
//     5 - June
//     6 - July
//     7 - August
//     8 - September
//     9 - October
//    10 - November
//    11 - December
export const month = readable(4);
export const year = readable(2025);

// showCalendar, boolean
export const showCalendar = writable(true);

// gradientEffect
//    0 - overlay
//    1 - subtle
//    2 - none
// export const gradientEffect = writable(0);
export const gradientEffect = writable(1);
// export const gradientEffect = writable(2);

// gradientDirection, for the overlay gradient
//    0 - top-down
//    1 - left-right
//    2 - right-left
export const gradientDirection = writable(0);

// retinaOutput, boolean
const isRetinaDisplay = window.devicePixelRatio != 1 ? true : false;
export const retinaOutput = writable(isRetinaDisplay);

// dimensions
// export const width = writable(1280);
// export const height = writable(800);
export const width = writable(1512);
export const height = writable(982);
// export const width = writable(414);
// export const height = writable(896);


export const presets = [
  // Mobile
  // [320, 568],
  [375, 812],
  [414, 896],
  // [1280, 720],
  [1280, 800],
  [1366, 768],
  [1512, 982],
  [1536, 864],
  [1920, 1080]
];
export const presetDefaultMobile = 1;
export const presetDefaultDesktop = 2;
// export const presetDefaultDesktop = 4;


// showCockerel, boolean
export const showCockerel = writable(true);
